<template>
  <div>
    <PdpaMkt />
  </div>
</template>

<script>
import ContractTable from "@/components/contractTable.vue";
import VueElementLoading from "vue-element-loading";
import PdpaMkt from "@/components/regis/PdpaMkt";

export default {
  components: { ContractTable, VueElementLoading, PdpaMkt },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {},
  methods: {
    async setup() {
      await this.fetchUserData(this.userId);
      await this.fetchContact();
      this.loading = false;
      this.loadingMain = false;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    userId() {
      return this.$store.getters.getUserid;
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-white {
  background-color: white;
  justify-content: space-evenly;
  padding: 15px 0;
}
</style>
